import React from 'react';
import { Link } from 'react-router-dom';
import ContactIcons from '../Contact/ContactIcons';
import routes from '../../data/routes';

const Footer = () => (
  <footer id="footer" className="footer-wrap">
    <div className="footer-container">
      <div className="footer-brand">
        <h2 className="footer-logo">
          <Link to="/">Yonatan Bebchuk</Link>
        </h2>
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Yonatan Bebchuk. All rights reserved.
        </p>
      </div>

      <div className="footer-links-grid">
        <div className="footer-column">
          <span className="footer-col-title">Navigation</span>
          <ul className="footer-col-links">
            {routes.map((l) => (
              <li key={l.label}>
                <Link to={l.path}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="footer-column">
          <span className="footer-col-title">Contact</span>
          <ul className="footer-col-links">
            <li>
              <a href="mailto:yonatanbebchuk@gmail.com">
                Email
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/yonatan-bebchuk/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn
              </a>
            </li>
            <li>
              <a
                href="https://github.com/yonatanbebchuk"
                target="_blank"
                rel="noopener noreferrer"
              >
                GitHub
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="footer-bottom">
      <div className="footer-bottom-container">
        <ContactIcons />
      </div>
    </div>
  </footer>
);

export default Footer;
